import React, {useState} from 'react'
import {ToggleButton, ToggleButtonGroup, RadioGroup, FormControlLabel, FormGroup, Checkbox, Radio} from '@mui/material'
import { useSelector } from 'react-redux'
import { selectQuestionById } from '../../../../reducers/survey_question'

const CheckboxYesNo = (props) => {
    const Question = useSelector(state=>selectQuestionById(state,props.question.QuestionId))

    
    const changeAnswer = (e, v) => {
            
            let Value = e.target.checked === true ? "42":"-1"
            props.saveAnswer(Value, Question.QuestionId)
            
        
    } 
    if(props){        
         return (            
            <FormGroup 
                color="primary"
                sx={{width:"100%"}}>
                    <FormControlLabel
                        control={
                            <Checkbox 
                                id={'checkbox-' + Question.QuestionId}
                                onChange={changeAnswer} 
                                checked={Question.Responses[0].Response==='42' ? true:false}
                                aria-label={Question.QuestionStandardContent}
                                aria-checked={Question.Responses[0].Response === '42' ? 'true' : 'false'}
            
                                />}
                        htmlFor={"checkbox-" + Question.QuestionId}
                        label={Question.QuestionStandardContent}
                        />
            </FormGroup>
        )
    } else return <p></p>
} 

export default CheckboxYesNo; 
